module.exports = __webpack_public_path__ + "static/media/preview.25de41c0.png";